/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["showBonusWorkerWindow"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        return Map2d.currentMap && Map2d.currentMap && Map2d.currentMap.workers.wantsToShowBonusWorkerWindow;
    },

    action: function () {
        const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
        if (locationConfig.usesWorkers && locationConfig.usesWorkers.bonusWorkers) {
            cleverapps.focusManager.display({
                focus: "BonusWorkerWindow",
                actions: [
                    function (f) {
                        new BonusWorkerWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                ]
            });
        }
    }
};

Placements.ENTRIES["showBoughtWorker"] = {
    type: Placements.FREE_FOCUS,
    priority: 8,
    filter: function () {
        return Map2d.currentMap && Map2d.currentMap.workers.wantsToShowBoughtWorker;
    },

    action: function () {
        Map2d.currentMap.workers.showBoughtWorker();
    }
};
